import React from "react";
import { useTranslation } from "react-i18next";

interface MyLeaveAgendaViewEventStateProps {
  event: {
    state: string;
    leaveType: string;
    [key: string]: any;
  };
}

export const MyLeaveAgendaViewEventState = ({
  event,
}: MyLeaveAgendaViewEventStateProps) => {
  const { t } = useTranslation();
  let borderColor, state;
  let eventState = event.state;
  let eventType = event.leaveType;
  let caseState = `${eventState}${
    eventType.charAt(0).toUpperCase() + eventType.slice(1)
  }`;

  const REQUESTED = t("OC_REQUESTED");
  const APPROVED = t("OC_APPROVED");

  switch (caseState) {
    case "requestedLeave":
      borderColor = "#f3aa18";
      state = REQUESTED;
      break;
    case "approvedLeave":
      borderColor = "#2fa84f";
      state = APPROVED;
      break;
    case "requestedAbsence":
      borderColor = "#F3AA18";
      state = REQUESTED;
      break;
    case "approvedAbsence":
      borderColor = "#2fa84f";
      state = APPROVED;
      break;
    case "currentLeaveRequest":
      borderColor = "#cc0033";
      state = REQUESTED;
      break;
    default:
      borderColor = "#f3aa18";
      state = REQUESTED;
  }

  return (
    <span
      style={{
        border: `1px solid ${borderColor}`,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 2,
        paddingBottom: 2,
        borderRadius: 16,
      }}
    >
      {state}
    </span>
  );
};

export default MyLeaveAgendaViewEventState;
